import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import TextField from '@mui/material/TextField'
import Select from 'react-select'
import { Checkbox, FormControlLabel } from '@mui/material'
import Axios from 'axios'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
import server from '../variables'

const ConsumerModal = ({ show, handleClose, schemeID, navigate, initialData,fetchdata }) => {
  const notyf = new Notyf()
  const [consumer, setConsumer] = useState(initialData || {})
  const [consumerType, setConsumerType] = useState(initialData?.consumerType || '')
  const [selectedDropdown, setSelectedDropdown] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if(initialData) {
      setConsumer(initialData);
      setConsumerType(initialData.consumerType || '');
      setSelectedDropdown(true);
    } else {
      setConsumer({});
      setConsumerType('');
      setSelectedDropdown(false);
    }
  }, [initialData, show]);

  const btnText = initialData ? 'Update Consumer' : 'Create Consumer'

  // Dropdown Options
  const ConsumerTypeList = [
    { label: 'Commercial Consumer', value: 'Commercial Consumer' },
    { label: 'Residential Consumer', value: 'Residential Consumer' },
    { label: 'Residential Cum Commercial Consumer', value: 'Residential Cum Commercial Consumer' },
  ]
  const bussinessNatureList = [
    { label: 'Hotel', value: 'Hotel' },
    { label: 'Resturant', value: 'Resturant' },
    { label: 'Public', value: 'Public' },
    { label: 'Semi Public', value: 'Semi Public' },
    { label: 'Hostels', value: 'Hostels' },
    { label: 'NGO', value: 'NGO' },
    { label: '12 Bed Hospitals', value: '12 Bed Hospitals' },
    { label: 'Hospitals(12+Bed)', value: 'Hospitals(12+Bed)' },
    { label: 'Industry', value: 'Industry' },
    { label: 'Marriage Garden/Hall', value: 'Marriage Garden/Hall' },
  ]
  const ownerShipStatusList = [
    { label: 'Govt', value: 'Govt' },
    { label: 'NGO', value: 'NGO' },
    { label: 'Private', value: 'Private' },
  ]
  const buildingType = [
    { label: 'Kacha', value: 'Kacha' },
    { label: 'Pakka', value: 'Pakka' },
  ]
  const propertyType = [
    { label: 'Single Floor', value: 'Single Floor' },
    { label: 'Duplex', value: 'Duplex' },
    { label: 'Bunglow', value: 'Bunglow' },
    { label: 'Bunglow with Farm', value: 'Bunglow with Farm' },
  ]
  const socialStatus = [
    { label: 'GEN', value: 'GEN' },
    { label: 'OBC', value: 'OBC' },
    { label: 'ST', value: 'ST' },
    { label: 'SC', value: 'SC' },
  ]
  const identityTypeConsumer = [
    { label: 'Company Name', value: 'Company Name' },
    { label: 'PAN Number', value: 'PAN Number' },
    { label: 'Gst Number', value: 'Gst Number' },
  ]
  const identityType = [
    { label: 'Aadhar', value: 'Aadhar' },
    { label: 'Passbook', value: 'Passbook' },
    { label: 'Passport', value: 'Passport' },
    { label: 'Driving License', value: 'Driving License' },
    { label: 'Voter ID', value: 'Voter ID' },
  ]

  // Handlers
  const handleInpChange = (e) => setConsumer({ ...consumer, [e.target.name]: e.target.value })
  const handleSelectChange = (field) => (data) => {
    setConsumer({ ...consumer, [field]: data.value })
    setSelectedDropdown(true)
  }

  // const submitConsumer = async (e) => {
  //   e.preventDefault()
  //   setIsLoading(true)

  //   if (!consumer.meterNumber || !consumer.latitude || !consumer.longitude) {
  //     notyf.error('Please fill Meter Number, Latitude, and Longitude!')
  //     setIsLoading(false)
  //     return
  //   }

  //   try {
  //     const { data } = await Axios.post(
  //       server + 'admin/new-consumer',
  //       { consumer, consumerType, schemeID },
  //       { headers: { authorization: localStorage.getItem('token') } }
  //     )
  //     setIsLoading(false)
  //     if (data.status === 200) {
  //       notyf.success(initialData ? 'Consumer updated!' : 'Consumer added!')
  //       handleClose()
  //       navigate(`/admin/scheme/${schemeID}/consumers`)
  //     } else {
  //       notyf.error(data.message || 'Something went wrong!')
  //     }
  //   } catch (err) {
  //     console.log(err)
  //     notyf.error('Internal server error!')
  //     setIsLoading(false)
  //   }
  // }

const submitConsumer = async (e) => {
  e.preventDefault()
  setIsLoading(true)

  if (!consumer.meterNumber || !consumer.latitude || !consumer.longitude) {
    notyf.error('Please fill Meter Number, Latitude, and Longitude!')
    setIsLoading(false)
    return
  }

  try {
    let url = ''
    let payload = {}

    if (initialData?.consumerID) {
      // ✅ UPDATE CASE
      url = server + 'admin/update-consumer/' + initialData?.consumerID
      payload = consumer
    } else {
      // ✅ CREATE CASE
      url = server + 'admin/new-consumer'
      payload = { consumer, consumerType, schemeID }
    }

    const { data } = await Axios.post(url, payload, {
      headers: { authorization: localStorage.getItem('token') },
    })

    setIsLoading(false)

    if (data.status === 200) {
      notyf.success(
        initialData?.consumerID ? 'Consumer updated!' : 'Consumer added!'
      )
      handleClose()
      fetchdata()
      navigate(`/admin/scheme/${schemeID}/consumers`)
    } else {
      notyf.error(data.message || 'Something went wrong!')
    }
  } catch (err) {
    console.log(err)
    notyf.error('Internal server error!')
    setIsLoading(false)
  }
}



  const commonFields = [
    { name: 'phoneNumber', label: 'Phone Number' },
      { name: 'mobileNumber', label: 'Mobile Number' },
    { name: 'email', label: 'Email' },
    { name: 'meterNumber', label: 'Meter Number' },
    { name: 'latitude', label: 'Latitude', type: 'number' },
    { name: 'longitude', label: 'Longitude', type: 'number' },
    { name: 'installationDate', label: 'Installation Date', type: 'date' },
    { name: 'waterRequirement', label: 'Water Requirement' },
  ]

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{initialData ? 'Update Consumer' : 'Add New Consumer'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="mb-3 col-6">
            <Select
              placeholder="Consumer Type"
              options={ConsumerTypeList}
              value={ConsumerTypeList.find(c => c.value === consumerType)}
              onChange={(data) => { setConsumerType(data.value); setSelectedDropdown(true) }}
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          {/* Render Commercial/Residential fields */}
          {(consumerType === 'Commercial Consumer' || consumerType === 'Residential Cum Commercial Consumer') && (
            <div className="row">
              <div className="mb-3 col-6">
                <TextField fullWidth label="Business Name" name="bussinessName" size="small" onChange={handleInpChange} value={consumer.bussinessName || ''} />
              </div>
              <div className="mb-3 col-6">
                <Select placeholder="Business Nature" options={bussinessNatureList} value={bussinessNatureList.find(b => b.value === consumer.bussinessNature)} onChange={handleSelectChange('bussinessNature')} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
              </div>
              <div className="mb-3 col-6">
                <Select placeholder="Ownership Status" options={ownerShipStatusList} value={ownerShipStatusList.find(o => o.value === consumer.ownershipStatus)} onChange={handleSelectChange('ownershipStatus')} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
              </div>
              <div className="mb-3 col-6 d-flex align-items-center">
                <FormControlLabel control={<Checkbox checked={consumer.isEducationInstitute || false} onChange={(e) => setConsumer({ ...consumer, isEducationInstitute: e.target.checked })} />} label="Is Educational Institute" />
              </div>
              <div className="mb-3 col-6">
                <Select placeholder="Identity Type" options={identityTypeConsumer} value={identityTypeConsumer.find(i => i.value === consumer.identityType)} onChange={handleSelectChange('identityType')} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
              </div>
              <div className="mb-3 col-6">
                <TextField fullWidth label="Identity Number" name="identityNumber" size="small" onChange={handleInpChange} value={consumer.identityNumber || ''} />
              </div>
            </div>
          )}

          {(consumerType === 'Residential Consumer' || consumerType === 'Residential Cum Commercial Consumer') && (
            <div className="row">
              <div className="mb-3 col-6">
                <TextField fullWidth label="Consumer Name" name="consumerName" size="small" onChange={handleInpChange} value={consumer.consumerName || ''} />
              </div>
              <div className="mb-3 col-6">
                <TextField fullWidth label="Father/Husband Name" name="fatherHusbandName" size="small" onChange={handleInpChange} value={consumer.fatherHusbandName || ''} />
              </div>
              <div className="mb-3 col-6">
                <Select placeholder="Building Type" options={buildingType} value={buildingType.find(b => b.value === consumer.buildingType)} onChange={handleSelectChange('buildingType')} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
              </div>
              <div className="mb-3 col-6">
                <Select placeholder="Property Type" options={propertyType} value={propertyType.find(p => p.value === consumer.propertyType)} onChange={handleSelectChange('propertyType')} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
              </div>
              <div className="mb-3 col-6">
                <Select placeholder="Identity Type" options={identityType} value={identityType.find(i => i.value === consumer.identityType)} onChange={handleSelectChange('identityType')} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
              </div>
              <div className="mb-3 col-6">
                <Select placeholder="Social Status" options={socialStatus} value={socialStatus.find(s => s.value === consumer.socialStatus)} onChange={handleSelectChange('socialStatus')} menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
              </div>
              <div className="mb-3 col-6 d-flex align-items-center">
                <FormControlLabel control={<Checkbox checked={consumer.isHandicape || false} onChange={(e) => setConsumer({ ...consumer, isHandicape: e.target.checked })} />} label="Is Handicaped" />
              </div>
              <div className="mb-3 col-6 d-flex align-items-center">
                <FormControlLabel control={<Checkbox checked={consumer.isBPL || false} onChange={(e) => setConsumer({ ...consumer, isBPL: e.target.checked })} />} label="Is BPL" />
              </div>
            </div>
          )}

          {selectedDropdown && (
            <div className="row">
              {commonFields.map(field => (
                <div className="mb-3 col-4" key={field.name}>
                  <TextField fullWidth label={field.label} name={field.name} type={field.type || 'text'} size="small" onChange={handleInpChange} value={consumer[field.name] || ''} />
                </div>
              ))}
            </div>
          )}

        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
        <Button variant="primary" onClick={submitConsumer} disabled={isLoading}>
          {isLoading ? <span className="spinner-border spinner-border-sm me-2" /> : btnText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConsumerModal
